import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { useDispatch, useSelector } from "react-redux";
import { accountApi } from "../api/account";
import { agentApi } from "../api/agent";
import { chatApi } from "../api/chat";
import { matchingApi } from "../api/matching";
import { preMatchingApi } from "../api/preMatching";
import account from "./slice/account";
import agent from "./slice/agent";
import chat from "./slice/chat";
import matching from "./slice/matching";
import modal from "./slice/modal";
import preMatching from "./slice/preMatching";

const rootReducer = combineReducers({
  account,
  agent,
  modal,
  preMatching,
  matching,
  chat,
  [accountApi.reducerPath]: accountApi.reducer,
  [agentApi.reducerPath]: agentApi.reducer,
  [preMatchingApi.reducerPath]: preMatchingApi.reducer,
  [matchingApi.reducerPath]: matchingApi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["modal/setAlertModal", "modal/setTwoButtonModal"],
        ignoredPaths: ["modal.alert.callback", "modal.twoButtonModal.callback"],
      },
    })
      .concat(accountApi.middleware)
      .concat(agentApi.middleware)
      .concat(preMatchingApi.middleware)
      .concat(matchingApi.middleware)
      .concat(chatApi.middleware),
});

setupListeners(store.dispatch);

export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;

export const modalSelector = (state) => state.modal;
export const accountSelector = (state) => state.account;
export const preMatchingSelector = (state) => state.preMatching;
export const matchingSelector = (state) => state.matching;
export const agentSelector = (state) => state.agent;
export const chatSelector = (state) => state.chat;
